import { SHOW_SUCCESS_MESSAGE } from "../actions/types";
const initialState = {
    success: ""
};
export default function(state = initialState, action) {
  switch (action.type) {
    case SHOW_SUCCESS_MESSAGE:
      return {
        ...state,
        success: action.payload
      }
    default:
      return state;
  }
}